import { HOME_X } from '../game/constants';
import { P } from './palette';
export function background(ctx:CanvasRenderingContext2D):void {
  ctx.fillStyle=P.black;ctx.fillRect(0,0,224,256);
  ctx.fillStyle=P.water;ctx.fillRect(0,24,224,104);
  ctx.fillStyle=P.green;ctx.fillRect(0,24,224,24);
  for(let y=25;y<48;y+=4)for(let x=0;x<224;x+=7){
    ctx.fillStyle=(x+y)%3===0?P.darkGreen:'#2da931';ctx.fillRect(x+(y%3),y,2,2);
  }
  for(const x of HOME_X){ctx.fillStyle=P.black;ctx.fillRect(x-10,32,20,15);ctx.fillStyle=P.green;ctx.fillRect(x-12,32,2,16);ctx.fillRect(x+10,32,2,16);}
  for(const y of [128,224]){
    ctx.fillStyle=P.median;ctx.fillRect(0,y,224,16);
    for(let x=0;x<224;x+=8){ctx.fillStyle=P.purple;ctx.fillRect(x,y,7,2);ctx.fillRect(x+2,y+7,5,1);ctx.fillStyle='#3d2c54';ctx.fillRect(x,y+14,7,2);}
  }
  // Sparse lane boundaries in the style of tile-era roadside markings.
  ctx.fillStyle='#393641';
  for(const y of [160,176,192,208])for(let x=5;x<224;x+=16)ctx.fillRect(x,y,8,1);
}
